module.exports = __webpack_public_path__ + "img/integral-app-1.751e5bdc.png";